import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Status } from '@df/core/status';
import { NewsletterFormComponentDef } from '@df/session/newsletter/newsletter-form.component.def';
import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';
import { CmsNewsletterBlockComponent } from '../cms/newsletter-block/cms-newsletter-block.component';

@Component({
    selector: 'checkout-success-newsletter',
    templateUrl: './checkout-success-newsletter.html',
    standalone: true,
    imports: [CmsNewsletterBlockComponent, FormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessNewsletterComponent extends NewsletterFormComponentDef implements OnInit {
    @Input({ required: true })
    email!: string;

    /**
     * Submission status
     */
    @Input()
    override readonly status = new Status();

    newsletterCheckbox = true;

    override ngOnInit() {
        super.ngOnInit();
        this.data.email = this.email;
    }

    dataChangeHandle(newsletter: boolean): void {
        this.newsletterCheckbox = newsletter;
        this.detectChanges();
    }

    override _submit() {
        if (this.newsletterCheckbox) {
            return this.subscribe();
        }
        return new Promise(resolve => {
            resolve(undefined);
        });
    }

    subscribe() {
        const data = <Newsletter.ISubscriptionFormData>{ source: this.source, ...this.data };
        return this.newsletter.subscribe(
            this.form,
            this.status,
            data,
            () => this.onSuccess(),
            () => this.onError()
        );
    }
}
